/*
 * App showcase tabs.
 *
 * Implements the tablist keyboard pattern: arrows move between tabs, Home and
 * End jump to the ends, and only the selected tab is in the tab order, so a
 * keyboard user tabs past the whole group rather than through every label.
 */

(function () {
  function init(scope) {
    (scope || document).querySelectorAll('[data-wake-app]').forEach(function (root) {
      if (root.dataset.wakeBound) return;
      root.dataset.wakeBound = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-wake-app-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-wake-app-panel]'));
      if (tabs.length < 2) return;

      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          const active = i === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });

        panels.forEach(function (panel, i) {
          const active = i === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        current = index;
        if (focus) tabs[index].focus();

        /* Only while autoplay is actually running — a tab the visitor picked
           themselves is not counting down to anything. */
        if (timer) runProgress(index);
      }

      /* Autoplay ------------------------------------------------------------
         Off unless the section asks for it. It never starts for someone who
         prefers reduced motion, pauses while the card is hovered, focused or
         the tab is in the background, and stops for good once the visitor
         picks a tab themselves — at that point they are driving. */
      const seconds = parseInt(root.dataset.wakeAutoplay, 10);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      let timer = null;
      let current = 0;
      let stopped = !Number.isFinite(seconds) || reduced.matches;
      let progress = null;

      /* The bar is driven from script rather than CSS because it has to
         restart on every tab change, and restarting a CSS animation means
         forcing a reflow. cancel() puts the bar back to zero width, which is
         also how it stays hidden on the tabs that are not running. */
      function runProgress(index) {
        if (progress) {
          progress.cancel();
          progress = null;
        }
        if (stopped) return;
        const bar = tabs[index].querySelector('[data-wake-app-progress]');
        if (!bar || !bar.animate) return;
        progress = bar.animate([{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], {
          duration: seconds * 1000,
          easing: 'linear',
          fill: 'forwards',
        });
      }

      function stopAutoplay() {
        stopped = true;
        pause();
        if (progress) {
          progress.cancel();
          progress = null;
        }
      }

      function pause() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
        if (progress) progress.pause();
      }

      function play() {
        if (stopped || timer || document.hidden) return;
        timer = setInterval(function () {
          current = (current + 1) % tabs.length;
          select(current, false);
        }, seconds * 1000);
        /* clearInterval discards however much of the interval had elapsed, so
           the bar starts over too rather than resuming out of step with it. */
        runProgress(current);
      }

      if (!stopped) {
        root.addEventListener('mouseenter', pause);
        root.addEventListener('mouseleave', play);
        root.addEventListener('focusin', pause);
        root.addEventListener('focusout', play);
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) pause();
          else play();
        });
        play();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          stopAutoplay();
          select(index, false);
        });

        tab.addEventListener('keydown', function (event) {
          let target = null;
          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = tabs.length - 1;
          if (target === null) return;

          event.preventDefault();
          stopAutoplay();
          select(target, true);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
